import DynamicForm from '@components/shared-ui-components/DynamicForm'
import { Paper } from '@mui/material'

function Ct3dGroundTruthEvaluationPage() {
  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '0px'
      }}
    >
      <h4>Please fill up the Ground-Truth Evaluation form</h4>
      <DynamicForm page={'ct3dGroundTruthEvaluation'} />
    </Paper>
  )
}

export default Ct3dGroundTruthEvaluationPage
